export enum FollowUpStatus {
  Pending = 0,
  Contacted = 1,
  Completed = 2,
  Cancelled = 3,
  Skipped = 4,
}

export interface FollowUp {
  id: string;
  organizationId: string;
  branchId?: string | null;
  clientId: string;
  appointmentId?: string | null;
  serviceId?: string | null;
  title?: string | null;
  notes?: string | null;
  dueAt: string;
  status: FollowUpStatus;
  priority: number;
  assignedTo?: string | null;
  assignedName?: string | null;
  lastActionAt?: string | null;
  lastActionNote?: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy?: string | null;
  updatedBy?: string | null;
  clientName?: string | null;
  clientPhone?: string | null;
  clientEmail?: string | null;
  clientAddress?: string | null;
  clientAge?: number | null;
}

export interface CreateFollowUpRequest {
  organizationId: string;
  branchId?: string;
  clientId: string;
  appointmentId?: string;
  serviceId?: string;
  title?: string;
  notes?: string;
  dueAt: string;
  status: FollowUpStatus;
  priority: number;
  assignedTo?: string;
  assignedName?: string;
}

export interface FollowUpUpdateModel {
  branchId?: string;
  title?: string;
  notes?: string;
  dueAt?: string;
  status?: FollowUpStatus;
  priority?: number;
  assignedTo?: string;
  assignedName?: string;
  lastActionNote?: string;
}